import React, { useState } from 'react'
import { isNil } from 'lodash'
import { useFlag } from 'toggled'

import AddToCartBlocker from '~/components/add-to-cart-blocker'
import { Counter } from '~/components/counter'
import { unitTooltipDuration } from '~/components/product/shared'
import { UnitTooltip } from '~/components/unit-tooltip'
import { useCartProps } from '~/hooks'
import Label from '~/truck/label'
import type { ILineItem } from '~/types/line-items'
import type { IProduct } from '~/types/products'
import { flags } from '~/utils/constants'
import { stack } from '~/variables'

import { CounterContainer, StyledCounterError } from './cta-counter.style'

export const CTACounter = (props: { activeVariant?: IProduct & ILineItem }) => {
  const { activeVariant } = props

  const { counterProps, returnedStock: activeVariantStock } = useCartProps({ ...activeVariant })

  const isNotAvailable = useFlag(flags.NOT_AVAILABLE)

  const hasUnits = useFlag(flags.UNITS)

  let stock = activeVariant?.stock

  const valueQuantity: number = activeVariant?.quantity ?? 0

  const [counterValue, setCounterValue] = useState(valueQuantity)

  const [counterError, setCounterError] = useState(null)

  if (!isNil(activeVariantStock)) {
    stock = activeVariantStock
  }

  const isOutOfStock = stock <= 0 || !counterProps.canJumpAtLeastOnce

  if (!activeVariant) {
    return (
      <Label as="span" $textStyle="h3Semibold">
        Variante no existe
      </Label>
    )
  }

  if (isOutOfStock) {
    return (
      <Label as="span" $textStyle="h3Semibold">
        Fuera de stock
      </Label>
    )
  }

  if (isNotAvailable) {
    return null
  }

  return (
    <AddToCartBlocker component={CounterContainer}>
      {!hasUnits ? (
        <Counter {...counterProps} alwaysOpen={true} onError={setCounterError} />
      ) : (
        <UnitTooltip
          visible={counterValue > 0}
          duration={unitTooltipDuration}
          salesUnitFactor={activeVariant.salesUnitFactor}
          inventoryUnitCode={activeVariant.inventoryUnit?.code}
          quantity={counterValue}
          zIndex={stack.mainHeader - 1}
        >
          <Counter
            {...counterProps}
            alwaysOpen={true}
            onError={setCounterError}
            onChange={value => {
              counterProps.onChange(value)
              setCounterValue(value)
            }}
          />
        </UnitTooltip>
      )}
      <StyledCounterError message={counterError} />
    </AddToCartBlocker>
  )
}
